import AbacusClientUtils from '@homeaway/abacus-client-utils';

const renderExperiments = {
    'inbox': 'HA_NATIVE_ADOPTION_BANNER_INBOX',
    'confirmation': 'HA_NATIVE_ADOPTION_PLACEMENT_BOOKING_CONFIRMATION',
    'serp': 'HA_NATIVE_ADOPTION_BANNER_SEARCH_UI',
    'homepage': 'HA_NATIVE_ADOPTION_BANNER_HP_V2'
};

function experimentIsValid(experimentName) {
    return (window !== 'undefined'
        && window.__ABACUS__
        && AbacusClientUtils.evaluateExperiment(experimentName));
}

function getExperimentValue(experimentName) {
    return experimentIsValid(experimentName) ? AbacusClientUtils.evaluateExperimentAndLog(experimentName).value : 0;
}

export {
    getExperimentValue,
    renderExperiments,
};
